import { BRAND_LEGAL_NAME, BRAND_SHORT_NAME } from '../../constants/brand.js';
import { DATA_PROTECTION_EMAIL } from '../../constants/legalContact.js';

/**
 * Política de privacidad del sitio web — complementa la política de tratamiento (Ley 1581/2012, Colombia).
 */
export const privacyPolicy = {
  id: 'privacy',
  title: 'Política de privacidad',
  updatedAt: '20 de mayo de 2025',
  intro: `La presente Política de Privacidad describe cómo ${BRAND_SHORT_NAME} (${BRAND_LEGAL_NAME}) recopila, usa y protege la información de quienes visitan y utilizan el portal web institucional, en concordancia con la Ley 1581 de 2012 y el régimen de Habeas Data en Colombia.`,
  sections: [
    {
      heading: '1. Alcance',
      paragraphs: [
        'Aplica a la navegación del sitio web, formularios públicos, cookies y tecnologías similares empleadas en el portal.',
        'La relación con asociados, empleados y proveedores en bases de datos institucionales se rige además por la Política de Tratamiento de Datos Personales de la Cooperativa.',
      ],
    },
    {
      heading: '2. Información que podemos recopilar',
      list: [
        'Datos de identificación y contacto: nombre, correo electrónico, teléfono, cuando los proporcione en formularios.',
        'Datos de navegación: dirección IP, tipo de navegador, páginas visitadas, fecha y hora de acceso, dispositivo.',
        'Datos técnicos generados por cookies o herramientas de analítica, si están habilitadas.',
        'Cualquier otro dato que usted entregue voluntariamente al usar el portal o canales de contacto.',
      ],
    },
    {
      heading: '3. Finalidad del uso en el portal',
      list: [
        'Responder solicitudes de información, PQRS y mensajes enviados por formularios.',
        'Mejorar la experiencia de usuario y la seguridad del sitio.',
        'Difundir información institucional sobre programas, noticias y servicios de la Cooperativa.',
        'Cumplir obligaciones legales y requerimientos de autoridades competentes.',
        'Prevenir usos indebidos, fraudes o ataques al sitio.',
      ],
    },
    {
      heading: '4. Base legal del tratamiento',
      paragraphs: [
        'El tratamiento se fundamenta en la autorización del titular, el cumplimiento de obligaciones legales, la ejecución de medidas precontractuales o contractuales solicitadas por el titular, y el interés legítimo de la Cooperativa en operar un portal seguro e informativo, siempre respetando los derechos del titular.',
      ],
    },
    {
      heading: '5. Cookies y tecnologías similares',
      paragraphs: [
        'El portal puede utilizar cookies propias o de terceros para funciones esenciales (sesión, preferencias) o, si se implementan, para estadísticas de uso.',
        'Puede configurar su navegador para rechazar cookies; algunas funciones del sitio podrían no operar correctamente.',
        'No utilizamos cookies para tratar datos sensibles sin autorización expresa e informada.',
      ],
    },
    {
      heading: '6. Compartición con terceros',
      paragraphs: [
        'No vendemos ni comercializamos datos personales. Podemos compartir información con proveedores de hosting, correo, mensajería o herramientas tecnológicas que actúan como encargados del tratamiento, bajo obligaciones de confidencialidad y seguridad.',
        'Podremos divulgar información cuando una autoridad competente lo exija en ejercicio de sus facultades legales.',
      ],
    },
    {
      heading: '7. Enlaces externos',
      paragraphs: [
        'El sitio puede contener enlaces a portales de terceros (pagos PSE, redes sociales, entidades de control, etc.). Las prácticas de privacidad de esos sitios son responsabilidad de sus titulares; le recomendamos leer sus políticas.',
      ],
    },
    {
      heading: '8. Seguridad',
      paragraphs: [
        'Aplicamos medidas razonables de seguridad digital y organizacional. Ningún sistema en Internet garantiza seguridad absoluta; le invitamos a proteger sus credenciales y dispositivos.',
      ],
    },
    {
      heading: '9. Derechos del titular',
      paragraphs: [
        'Usted puede ejercer los derechos de acceso, actualización, rectificación y supresión, y revocar la autorización, conforme a la Ley 1581 de 2012.',
        `Para consultas o reclamos relacionados con datos personales, escriba a ${DATA_PROTECTION_EMAIL} o utilice los canales indicados en la Política de Tratamiento de Datos Personales.`,
        'Ante el incumplimiento de los términos legales por parte del responsable, puede presentar reclamo ante la Superintendencia de Industria y Comercio (SIC).',
      ],
    },
    {
      heading: '10. Menores de edad',
      paragraphs: [
        'El portal no está dirigido a menores de edad para el tratamiento de sus datos sin el consentimiento de su representante legal, salvo las excepciones previstas en la ley.',
      ],
    },
    {
      heading: '11. Cambios a esta política',
      paragraphs: [
        'Podemos actualizar esta Política de Privacidad. La fecha de la última actualización se indicará al inicio del documento. El uso continuado del sitio tras la publicación de cambios implica conocimiento de la versión vigente.',
      ],
    },
    {
      heading: '12. Contacto',
      paragraphs: [
        `Responsable: ${BRAND_LEGAL_NAME} — ${BRAND_SHORT_NAME}.`,
        `Correo: ${DATA_PROTECTION_EMAIL}.`,
        'También puede contactarnos mediante el formulario de la sección Contacto / PQRS del portal.',
      ],
    },
  ],
};
